import React from 'react';
import { TentIcon, QrCodeIcon, PercentIcon, ArrowRightIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
type FairPromotionProps = {
  fair: any;
  onClose: () => void;
};
export const FairPromotion: React.FC<FairPromotionProps> = ({
  fair,
  onClose
}) => {
  if (!fair) return null;
  // Format date range for display
  const formatDateRange = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    // Format options
    const options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };
    return `${start.toLocaleDateString('en-US', options)} - ${end.toLocaleDateString('en-US', options)}`;
  };
  return <div className="bg-gradient-to-r from-amber-600/90 to-amber-700/90 backdrop-blur-sm border border-amber-500/50 rounded-xl p-4 shadow-xl relative overflow-hidden" data-id="element-3319">
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/20 rounded-full filter blur-3xl -z-10" data-id="element-3320"></div>
      <div className="flex items-center" data-id="element-3321">
        <div className="hidden sm:block mr-4" data-id="element-3322">
          <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center" data-id="element-3323">
            <QrCodeIcon size={40} className="text-amber-600" data-id="element-3324" />
          </div>
        </div>
        <div className="flex-1" data-id="element-3325">
          <div className="flex items-center mb-1" data-id="element-3326">
            <TentIcon size={18} className="text-white mr-2" data-id="element-3327" />
            <h3 className="text-white font-bold text-lg" data-id="element-3328">{fair.name}</h3>
          </div>
          <div className="flex flex-wrap gap-2 mb-2 text-xs text-amber-100" data-id="element-3329">
            <div className="flex items-center" data-id="element-3330">
              <MapPinIcon size={12} className="mr-1" data-id="element-3331" />
              {fair.location}
            </div>
            <div className="flex items-center" data-id="element-3332">
              <CalendarIcon size={12} className="mr-1" data-id="element-3333" />
              {formatDateRange(fair.startDate, fair.endDate)}
            </div>
          </div>
          <div className="flex items-center mb-3" data-id="element-3334">
            <PercentIcon size={16} className="text-amber-200 mr-1" data-id="element-3335" />
            <p className="text-white text-sm font-medium" data-id="element-3336">
              ¡Escanea el código QR en la feria para obtener un 40% de descuento
              en todas las cotizaciones!
            </p>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-3337">
            <button className="bg-white text-amber-700 hover:bg-amber-100 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors flex items-center" data-id="element-3338">
              Crear Cotización
              <ArrowRightIcon size={14} className="ml-1" data-id="element-3339" />
            </button>
            <button onClick={onClose} className="bg-white/20 text-white hover:bg-white/30 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors" data-id="element-3340">
              Descartar
            </button>
          </div>
        </div>
        <button onClick={onClose} className="absolute top-2 right-2 text-white/80 hover:text-white bg-black/10 hover:bg-black/20 rounded-full p-1" data-id="element-3341">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-3342">
            <line x1="18" y1="6" x2="6" y2="18" data-id="element-3343"></line>
            <line x1="6" y1="6" x2="18" y2="18" data-id="element-3344"></line>
          </svg>
        </button>
      </div>
    </div>;
};